/**
 * Нормализует data блока department_facts_contacts.
 * Поддерживает плоскую модель и legacy { facts, contacts }.
 */
export function normalizeDepartmentFactsContactsData(raw) {
  const data = raw && typeof raw === 'object' ? raw : {}

  if (data.facts || data.contacts) {
    const facts = data.facts && typeof data.facts === 'object' ? data.facts : {}
    const contacts = data.contacts && typeof data.contacts === 'object' ? data.contacts : {}
    const cards = Array.isArray(facts.cards) ? facts.cards : []

    const scheduleFromCards = []
    const compositionFromCards = []
    cards.forEach((card) => {
      if (!card || typeof card !== 'object') return
      const title = String(card.title || '').toLowerCase()
      const items = Array.isArray(card.items) && card.items.length
        ? card.items.map((i) => String(i).trim()).filter(Boolean)
        : String(card.content || '').trim()
          ? [String(card.content).trim()]
          : []
      if (title.includes('адрес') || title.includes('контакт')) return
      if (title.includes('режим') || title.includes('время') || title.includes('график')) {
        scheduleFromCards.push(...items)
        return
      }
      if (title.includes('состав')) {
        compositionFromCards.push(...items)
        return
      }
    })

    return {
      heading: String(contacts.heading || facts.heading || 'Контакты отделения').trim() || 'Контакты отделения',
      updatedAt: String(facts.updatedAt || data.updatedAt || '').trim(),
      phones: Array.isArray(contacts.phones) ? contacts.phones : [],
      email: String(contacts.email || '').trim(),
      address: String(contacts.address || '').trim(),
      mapImage: String(contacts.mapImage || '').trim(),
      mapAlt: String(contacts.mapAlt || '').trim(),
      scheduleItems: Array.isArray(data.scheduleItems) && data.scheduleItems.length
        ? data.scheduleItems
        : scheduleFromCards,
      compositionItems: Array.isArray(data.compositionItems) && data.compositionItems.length
        ? data.compositionItems
        : compositionFromCards,
      disclaimer: String(facts.disclaimer || data.disclaimer || '').trim(),
    }
  }

  return {
    heading: String(data.heading || 'Контакты отделения').trim() || 'Контакты отделения',
    updatedAt: String(data.updatedAt || '').trim(),
    phones: Array.isArray(data.phones) ? data.phones : [],
    email: String(data.email || '').trim(),
    address: String(data.address || '').trim(),
    mapImage: String(data.mapImage || '').trim(),
    mapAlt: String(data.mapAlt || '').trim(),
    scheduleItems: Array.isArray(data.scheduleItems) ? data.scheduleItems : [],
    compositionItems: Array.isArray(data.compositionItems) ? data.compositionItems : [],
    disclaimer: String(data.disclaimer || '').trim(),
  }
}
